var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDownSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 7.081,
    viewBox: "0 0 14 7.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.84.161a.547.547,0,0,0-.773,0L7.387,5.828a.548.548,0,0,1-.774,0L.933.16A.547.547,0,0,0,.161.934L5.84,6.6a1.642,1.642,0,0,0,2.32,0L13.839.934A.547.547,0,0,0,13.84.161Z",
    fill: "#4788ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownSelect);
export default __webpack_public_path__ + "static/media/drop-down-select.a761ce23e03d56f0de5978c1eb00eb00.svg";
export { ForwardRef as ReactComponent };